import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Options } from '@angular-slider/ngx-slider';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { DataFlightService, HttpService, HubSpokeService, HubSpokeAcknowledgeService, LoaderService, TopFlightsService, UtilityFlightService, UtilityService, XchangeratesService } from 'src/app/services';
import { CryptoService } from 'src/app/services/crypto.service';
import { AirlinelistComponent } from '../airlinelist/airlinelist.component';
import { Observable, BehaviorSubject, forkJoin } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { FlightBookingLoaderComponent } from 'src/app/shared/loader/flight/flight-booking-loader/flight-booking-loader.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewMultiFareComponent } from '../view-multi-fare/view-multi-fare.component';


@Component({
  selector: 'app-one-way',
  templateUrl: './one-way.component.html',
  styleUrls: ['./one-way.component.scss']
})
export class OneWayComponent implements OnInit {
  @Input() listStop: string;
  trip_type;
  isLoading: boolean = false;
  isBookingLoader: boolean = false;
  filter = false;
  list;
  value: number = 0;
  flight_list: any[] = [];
  flight_Details: boolean[] = [];
  flight_Details__: boolean[] = [false, false, false];
  openIndex: number | null = null;
  minValue: number;
  maxValue: number;
  stops = this.data.stopList;
  isSelectedTrip;
  flightTime = this.data.flightTime;
  flightTimeArr = this.data.flightTime__;
  activeStates: { id: number, value: number, isSelected: boolean }[] = this.stops.map(stop => ({ id: stop.id, value: stop.value, isSelected: stop.isSelected }));
  activeDepart: { [key: string]: boolean } = {};
  activeArrival: { [key: string]: boolean } = {};
  flightcarrier_: any = [];
  newListCarrier: any = [];
  uniqueCarrierNames: any[] = [];
  currentOrder: string = 'asc';
  viewMoreFare = this.util_flight.viewMoreFare;
  step = 0;  // Variable to keep track of the currently open panel
  // maxValue: any;
  options: Options = {
    floor: 0,
    ceil: 0,
  };
  list_error;
  listCalandarPrice: any;
  isCardVisible: boolean = true;
  filterApplied: boolean = false;
  selectedAirlines: any[] = [];
  currentIndex: number = 0; 
  itemsPerPage: number = 3;
  isMobile: boolean = false;
  flightList: any[] = [];  // Store all flight data
  displayedFlights: any[] = [];  // Flights to display (10 by default)
  showAllFlights: boolean = false;
  limit: number = 10; 
  flightBanner: any[]
  urlDomastics;
  activeIndex__: number | null = 0; // Initially, the first index is active.

  constructor(public http: HttpService, public loaderService: LoaderService, public util: UtilityService, public router: Router,
    private route: ActivatedRoute, private cryptoService: CryptoService, public data: DataFlightService, private dialog: MatDialog, private cdr: ChangeDetectorRef,
    public util_flight: UtilityFlightService, public Xchangerates: XchangeratesService, private breakpointObserver: BreakpointObserver, private flights__: TopFlightsService,
    private hubSpokeService: HubSpokeService, private hubSpokeAcknowledgeService: HubSpokeAcknowledgeService) {
    this.trip_type = JSON.parse(localStorage.getItem('flight_search')!);
    const action = () => { this.trip_type = JSON.parse(localStorage.getItem('flight_search')!); this.fetchFlightList(); };
    window.location.pathname.includes('cheap-flights') ? setTimeout(action, 3000) : action();
    // this.fetchFlightList();
    // Call filterFlightList initially to set the initial filtered list
    // this.filterFlightList(selectedStop);
    this.DynamicCalandarPrice();
    localStorage.removeItem('PassangerRule');
    this.urlDomastics = this.util_flight.getFlightsByType();
    
  }
  ngOnInit(): void { 
    this.initializeValues();
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
      this.itemsPerPage = this.isMobile ? 1 : 3;
    });

    const action = () => {
    const flightSearch = localStorage.getItem('flight_search');
    if (flightSearch) {
      this.trip_type = JSON.parse(flightSearch);
      this.fetchFlightList();
    } else {
      console.warn('No flight_search found in localStorage');
    }
  };

  // Delay for SEO pages or cheap-flights path
  window.location.pathname.includes('cheap-flights') 
    ? setTimeout(action, 3000) 
    : action();

  // Subscribe to flightSearchData$ to update list and log
  this.flights__.flightSearchData$.subscribe(flight => {
    const flightSearch = localStorage.getItem('flight_search');
    this.trip_type = JSON.parse(flightSearch);
    if (flight) this.fetchFlightList();
  });
  }

  toggleFilterVisibility() {
    this.filter = !this.filter;

    
    
    if (this.filter) {
      this.restoreFilterState();
      this.isCardVisible = true; 
      this.handleScrollControl(); 
    } else {
      this.isCardVisible = false; 
      this.enableBodyScroll(); 
    }
  }


  toggleCardVisibility() {
    this.isCardVisible = !this.isCardVisible;

    this.handleScrollControl(); 

  }
  preventBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  // Enable scrolling on the body
  enableBodyScroll() {
    document.body.style.overflow = 'auto';
  }

  handleScrollControl() {
    if (!this.util.istabletView() && this.isCardVisible) {
      this.preventBodyScroll();
    } else {
      this.enableBodyScroll(); 
    }
  }


  private fetchFlightList(): void {
    this.isLoading = true;
    this.http.flightsave('apiV2/flight/search-multi-fare', this.trip_type).pipe(
      map((res) => {
        if (res.statusCode === 200) {
          this.list = res.data;
          this.flight_list = this.router.url.includes('/cheap-flights')
            ? res.data.flightjourneys.slice(0, 12)
            : res.data.flightjourneys;
          return this.flight_list;
        }
        throw res.errorCode === 200 ? new Error('No data found.') : null;
      }),
      tap((flightlist) =>
        this.router.url.includes('/cheap-flights')
          ? this.fetchBannerList(flightlist)
          : this.processBannerList([], flightlist)
      ),
      catchError((err) => {
        this.util.errorMessage(err);
        this.list_error = 0;
        return [];
      })
    ).subscribe({ complete: () => (this.isLoading = false) });
  }
  flight_list_filter: any [] = [];


  toggleFlights(): void {
    if (this.router.url.split('?')[0].includes('cheap-flights')) {
      this.showAllFlights = !this.showAllFlights;
      if (this.showAllFlights) {
        this.flight_list = [...this.list.flightjourneys];  // Show all flights
        this.processBannerList(this.flightBanner, this.flight_list);
        
      } else {
        this.flight_list = this.list.flightjourneys.slice(0, 12);  // Limit to 10
        this.processBannerList(this.flightBanner, this.flight_list);

        this.cdr.detectChanges();
      }
    }
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  
  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }
  
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  fetchBannerList(flightlist: any[]): void {
    this.http.flightget('apiV2/bookingClass/search-page-banner-list').subscribe({
      next: (res) => {
        const bannerPromo = this.util_flight.getFlightsByType(); 
        const filteredData = res.data.filter((item: any) => item.way_type === 'BOTH' || (item.way_type === 'DOMESTIC' && (bannerPromo.type === 'domestic' || bannerPromo.type === 'both')) || (item.way_type === 'INTERNATIONAL' && (bannerPromo.type === 'international' || bannerPromo.type === 'both')) || item.way_type === null).sort((a: any, b: any) => a.banner_priority === null ? 1 : b.banner_priority === null ? -1 : a.banner_priority - b.banner_priority);
        
        this.flightBanner = filteredData
        this.processBannerList(filteredData, flightlist);
      },
      error: () => this.processBannerList([], flightlist)
    });
  }
  
  private processBannerList(bannerlist: any[], flightlist: any[]): void {
    const mergedList = [];
    let bannerIndex = 0;
    for (let i = 0; i < flightlist?.length; i++) {
      mergedList.push({ ...flightlist[i], name: 'flight' });
      if ((i + 1) % 3 === 0 && i !== flightlist?.length - 1 && bannerlist?.length) {
        mergedList.push({ ...bannerlist[bannerIndex], name: 'banner' });
        bannerIndex = (bannerIndex + 1) % bannerlist.length;
      }
    }
    this.flight_list = mergedList;
    this.flight_list_filter = mergedList;
    // console.log(mergedList);
    
    this.carrer_list(this.flight_list);
    this.lowhighList(flightlist);
    this.isLoading = false;
  }

  lowhighList(flightlist: any[]) {
    // Check if the mergedList is not empty
    if (flightlist.length === 0) {
      console.log('The mergedList is empty.');
      return;
    }

    // Initialize variables to store the minimum and maximum values
    let lowestValue = Number.MAX_VALUE;
    let highestValue = Number.MIN_VALUE;

    for (const item of flightlist) {
      // Assuming each item in mergedList has a numeric value
      const value = parseFloat(item.multifares[0].flightfare.totalnet); // Convert the value to a number (assuming it's a string) // {{.multifares[0]}} For multifate
      // Check for the lowest value
      if (!isNaN(value) && value < lowestValue) {
        lowestValue = value;
      }
      // Check for the highest value
      if (!isNaN(value) && value > highestValue) {
        highestValue = value;
      }
    }
    // Log the lowest and highest values
    this.minValue = lowestValue;
    this.maxValue = highestValue;
    this.options.floor = lowestValue;
    this.options.ceil = highestValue;
  }

  carrer_list(flight_list: any[]) {
    const newList: any[] = flight_list.map((flight_List_) => flight_List_);
    const filteredList: any[] = newList.filter((item) => item.name !== 'banner');
    const carrierList_: string[] = filteredList.flatMap((flight) => flight.flightlegs);
    const carrierNames: string[] = carrierList_.map((carrier) => carrier);
    const allCarrierNames: any[] = [];
    for (const carrierName of carrierNames) {
      for (const listcarrier of carrierName) {
        this.flightcarrier_ = listcarrier;
        this.newListCarrier = { carriername: this.flightcarrier_.carriername, carrier: this.flightcarrier_.carrier };
        allCarrierNames.push(this.newListCarrier);
      }
    }
    const uniqueCarrierNames = Array.from(new Set(allCarrierNames.map(carrier => `${carrier.carriername} (${carrier.carrier})`)));
    const uniqueCarrierNames_ = uniqueCarrierNames.map(carrier => {
      const code = carrier.match(/\((.*?)\)/)?.[1] || ''; // Extract code between parentheses
      return { name: carrier, code: code, isSelected: false };
    });
    this.uniqueCarrierNames = uniqueCarrierNames_;
    this.util_flight.setCarrierNames(uniqueCarrierNames_);
  }

  flightInfo(i: number): void {
    this.flight_Details[i] = !this.flight_Details[i];
    this.flight_Details__[i] && (this.flight_Details__[i] = false);
  }

  flightInfo__(index: any): void {
    const dialogRefMULTIFARE = this.dialog.open(ViewMultiFareComponent, {
      data: index, 
      panelClass: 'flight_multiFare-dialog-container'
    });

    dialogRefMULTIFARE.afterClosed().subscribe((result) => {
      if(result) {
        this.submit(result.item, result.item_fare)
      }
    })
  }

  submit(item, item_fare) {
    this.proceedSubmit(item, item_fare);
  }

  proceedSubmit(item, item_fare) {
    this.isBookingLoader = true; // this is using for Booking Loader
    const url = item_fare.flightdeeplinkurl.startsWith('/') ? item_fare.flightdeeplinkurl.slice(1) : item_fare.flightdeeplinkurl;
    const urlObject = new URL(url);
    // console.log(urlObject.pathname);

    const searchParams = urlObject.searchParams;
    const queryString = new URLSearchParams(searchParams).toString();

    this.http.flightgetall(`${urlObject.pathname}?${queryString}`).subscribe((res) => {
      if(res) {
        localStorage.setItem('flightSelect_0', JSON.stringify({infoFlight: item, infoFare: item_fare}));  // localStorage.setItem('flightSelect_0', JSON.stringify(item));
        const bookingId = this.cryptoService.encrypt(res.booking_id);
        localStorage.setItem('bookingId', bookingId);
        localStorage.setItem('trip_type__', 'oneWayTrip');
        localStorage.setItem('PassangerRule', JSON.stringify(res));
        const id = res.booking_id;
        // this.util_flight.pushPassangerRule(res);
        const isCheapFlights = window.location.pathname.includes('cheap-flights');
        if (isCheapFlights) {
          const targetUrl = this.router.createUrlTree([`../../flights/bookings/${id}`], { relativeTo: this.route }).toString();
          window.open(targetUrl, '_blank');
        } else {
          this.router.navigate([`../bookings/${id}`], { relativeTo: this.route });
        }
        // const url = this.router.createUrlTree([`../bookings/${id}`], { relativeTo: this.route }).toString();
        // window.open(url, '_blank');
        this.isBookingLoader = false; // this is using for Booking Loader
        // console.log(id, 'Booking ID');
        // this.router.navigate([`../../booking/${id}`], { relativeTo: this.route }); // This will be used in future after getting payment result
      }
    }, err => {
      this.util.errorMessage(err);
      this.isBookingLoader = false;
    });
  }

  airlinelist(item) {
    const selectedItems = item.filter(i => i.isSelected);
    const dialogRef = this.dialog.open(AirlinelistComponent, {
      data: { allItems: item, selectedItems },
      width: '520px',
      panelClass: 'flight_airlinelist-dialog-container',
      disableClose: true
    });
    // dialogRef.componentInstance.airlinesSelected.subscribe(selectedAirlines => {
    // });
    dialogRef.afterClosed().subscribe(result => {
      this.updateFlightList(result ?? []);
      this.uniqueCarrierNames = this.uniqueCarrierNames.map(i => ({
        ...i,
        isSelected: (result ?? []).some(selected => selected.name === i.name) || false
      }));
    });
  }

  private updateFlightList(selectedAirlines: any[]) {
    if (selectedAirlines?.length === 0) {
      this.flight_list = this.flight_list_filter;
    } else {
      this.flight_list = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
          selectedAirlines.some(selectedItem => flightleg.carrier === selectedItem.code)
        )
      );
    }
  }




  applyFilters() {
    this.filterApplied = true;
    this.flight_list = this.flight_list_filter.filter(flight => {
      // Stops filter
      const meetsStops = this.activeStates.filter(state => state.isSelected).length === 0 ||
        this.activeStates.filter(state => state.isSelected).some(selectedStop =>
          flight.layovers && flight.layovers[0] &&
          Object.keys(flight.layovers[0]).length === selectedStop.value
        );
  
      // Airlines filter
      const selectedAirlines = this.uniqueCarrierNames.filter(item => item.isSelected);
      const meetsAirlines = selectedAirlines.length === 0 || 
        flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
          selectedAirlines.some(selectedItem => flightleg.carrier === selectedItem.code)
        );
  
      // Departure time filter
      const meetsDepartureTime = this.selectedDepartureTimeRanges.length === 0 ||
        flight.flightlegs && flight.flightlegs[0][0] &&
        this.selectedDepartureTimeRanges.some(range =>
          flight.flightlegs[0][0].deptime >= range.startTime && flight.flightlegs[0][0].deptime <= range.endTime
        );
  
      // Arrival time filter
      const meetsArrivalTime = this.selectedArrivalTimeRanges.length === 0 ||
        flight.flightlegs && flight.flightlegs[0][flight.flightlegs[0].length - 1] &&
        this.selectedArrivalTimeRanges.some(range =>
          flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime >= range.startTime && flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime <= range.endTime
        );
  
      // Price filter
      // const meetsPrice = flight.multifares?.[0]?.flightfare?.totalnet != null &&
      //   flight.multifares?.[0]?.flightfare?.totalnet >= this.minValue &&
      //   flight.multifares?.[0]?.flightfare?.totalnet <= this.maxValue;

        const meetsPrice = flight.multifares?.[0]?.flightfare?.totalnet != null &&
        (!this.minValue || flight.multifares[0].flightfare.totalnet >= this.minValue) &&
        (!this.maxValue || flight.multifares[0].flightfare.totalnet <= this.maxValue);
  
      // Combine all conditions
      return meetsStops && meetsAirlines && meetsDepartureTime && meetsArrivalTime && meetsPrice;
    });
  }
  

  // This Filter is used for Stops
  selectStop(stop: any) {
    stop.isSelected = !stop.isSelected;
    this.activeStates = this.stops.map(stop => ({
      id: stop.id, value: stop.value, isSelected: stop.isSelected
    }));
    this.applyFilters();
  }

  // This Filter is used for Airlines
  // filter_airline(item: any) {
  //   item.isSelected = !item.isSelected;
  //   this.applyFilters();
  // }


  filter_airline(item: any) {
    item.isSelected = !item.isSelected;
    const existingIndex = this.selectedAirlines.findIndex(
      airline => airline.name === item.name
    );
  
    if (existingIndex > -1) {
      if (item.isSelected) {
        this.selectedAirlines[existingIndex].isSelected = item.isSelected;
      } else {
        this.selectedAirlines.splice(existingIndex, 1); 
      }
    } else if (item.isSelected) {
      this.selectedAirlines.push({ name: item.name, isSelected: item.isSelected });
    }
    this.applyFilters();
  }
  
  restoreFilterState() {
    this.uniqueCarrierNames.forEach(item => {
      const selected = this.selectedAirlines.find(airline => airline.name === item.name);
      item.isSelected = !!selected; 
    });
  }

  private filterFlightList(selectedStops: any[], selectedAirlines: any[]) {
    const filterCondition = (flight: any, length: number) => flight.layovers && flight.layovers[0] && Object.keys(flight.layovers[0]).length === length;

    if (!selectedStops.length && !selectedAirlines.length) {
      this.flight_list = this.flight_list_filter;
      console.log(this.flight_list);
      return;
    }

    this.flight_list = this.flight_list_filter.filter(flight =>
      (!selectedStops.length || selectedStops.some(selectedStop => selectedStop.value >= 0 && selectedStop.value <= 3 && selectedStop.isSelected && filterCondition(flight, selectedStop.value))) &&
      (!selectedAirlines.length || flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
        selectedAirlines.some(selectedItem => flightleg.carrier === selectedItem.code)
      ))
    );
  }

  selectedDepartureTimeRanges: { startTime: string, endTime: string }[] = [];
  selectedArrivalTimeRanges: { startTime: string, endTime: string }[] = [];

  selectDepart(item: any) {
    item.isSelected = !item.isSelected;
    const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
    if (item.isSelected) {
      this.selectedDepartureTimeRanges.push({
        startTime: timeRanges[item.id].split('-')[0],
        endTime: timeRanges[item.id].split('-')[1]
      });
    } else {
      this.selectedDepartureTimeRanges = this.selectedDepartureTimeRanges.filter(range =>
        !(range.startTime === timeRanges[item.id].split('-')[0] &&
          range.endTime === timeRanges[item.id].split('-')[1])
      );
    }
    this.applyFilters();
  }

  private filterByDepartureTime() {
    if (this.selectedDepartureTimeRanges.length > 0) {
      const filteredFlights = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs[0][0] &&
        this.selectedDepartureTimeRanges.some(range =>
          flight.flightlegs[0][0].deptime >= range.startTime && flight.flightlegs[0][0].deptime <= range.endTime
        )
      );
      this.flight_list = filteredFlights;
    } else {
      // If no time ranges are selected, show all flights
      this.flight_list = this.flight_list_filter;
    }
  }

  selectArrival(item: any) {
    item.isSelected_ = !item.isSelected_;
    const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
    if (item.isSelected_) {
      this.selectedArrivalTimeRanges.push({
        startTime: timeRanges[item.id].split('-')[0],
        endTime: timeRanges[item.id].split('-')[1]
      });
    } else {
      this.selectedArrivalTimeRanges = this.selectedArrivalTimeRanges.filter(range =>
        !(range.startTime === timeRanges[item.id].split('-')[0] &&
          range.endTime === timeRanges[item.id].split('-')[1])
      );
    }
    this.applyFilters();
  }

  private filterByArrivalTime() {
    if (this.selectedArrivalTimeRanges.length > 0) {
      const filteredFlights = this.flight_list_filter.filter(flight =>
        flight.flightlegs && flight.flightlegs[0][flight.flightlegs[0].length - 1] &&
        this.selectedArrivalTimeRanges.some(range =>
          flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime >= range.startTime && flight.flightlegs[0][flight.flightlegs[0].length - 1].arrtime <= range.endTime
        )
      );
      this.flight_list = filteredFlights;
    } else {
      // If no time ranges are selected, show all flights
      this.flight_list = this.flight_list_filter;
    }
  }

  // onValueChange(event: any) {
  //   this.minValue = event.min;
  //   this.maxValue = event.max;
  //   this.applyFilters();
  // }

  onValueChange(event: any) {
    this.cdr.detectChanges();
    this.flight_list = this.filterFlights(this.minValue, this.maxValue);
    this.applyFilters();
  }
  
  
  filterFlights(minValue: number, maxValue: number): any[] {
    const filteredFlights = this.flight_list_filter.filter(flight =>
      flight.multifares?.[0]?.flightfare && flight.multifares?.[0]?.flightfare.totalnet != null &&
      flight.multifares?.[0]?.flightfare.totalnet >= minValue && flight.multifares?.[0]?.flightfare.totalnet <= maxValue
    );
    if (filteredFlights.length === 0) this.flight_list = this.flight_list_filter;
    return filteredFlights;
  }

  sortBy(criteria: string) {
    if (this.currentOrder === 'asc') {
      switch (criteria) {
        case 'departure':
        case 'arrive':
          this.sortFlightList('asc');
          break;
        case 'price':
          this.sortFlightPrice('asc');
          break;
        case 'duration':
          this.sortFlightDuration('asc');
          break;
        // Add cases for other criteria if needed
      }
      this.currentOrder = 'desc';
    } else {
      switch (criteria) {
        case 'departure':
        case 'arrive':
          this.sortFlightList('desc');
          break;
        case 'price':
          this.sortFlightPrice('desc');
          break;
          case 'duration':
          this.sortFlightDuration('desc');
          break;
        // Add cases for other criteria if needed
      }
      this.currentOrder = 'asc';
    }
  }

  sortFlightDuration(order: string) {
    const sortOrder = order === 'asc' ? 1 : -1;
    const durations = this.flight_list_filter
      .map(flight => {
        const totalDuration = flight.totaljourneyduration || 0;
        return { flight, totalDuration };
      })
      .sort((a, b) => (a.totalDuration - b.totalDuration) * sortOrder);
    this.flight_list = durations.map(item => item.flight);
  }

  sortFlightList(order: string) {
    const departureTimes = this.flight_list_filter
      .map(flight => flight.flightlegs?.[0]?.[0]?.deptime)
      .filter(departureTime => departureTime);
    const sortOrder = order === 'asc' ? 1 : -1;
    departureTimes.sort((a, b) => (this.util_flight.convertTimeStringToMinutes(a) - this.util_flight.convertTimeStringToMinutes(b)) * sortOrder);
    this.flight_list = departureTimes.map(departureTime => this.flight_list_filter.find(flight => flight.flightlegs?.[0]?.[0]?.deptime === departureTime));
  }

  // sortFlightPrice(order: string) {
  //   const priceFlight = this.flight_list_filter
  //   .map(flight => flight.multifares?.[0]?.flightfare)
  //   .filter(totalnet => totalnet);
  //   const priceOrder = order === 'asc' ? 1 : -1;
  //   priceFlight.sort((a, b) => (a - b) * priceOrder);
  //   if (order === 'desc') priceFlight.reverse();
  //   this.flight_list = priceFlight.map(price => this.flight_list_filter.find(flight => flight.multifares?.[0]?.flightfare === price));
  // }

  sortFlightPrice(order: string) {
    const priceOrder = order === 'asc' ? 1 : -1;
  
    // Filter out flights with missing or invalid price data
    const priceFlight = this.flight_list_filter
      .filter(flight => flight.multifares?.[0]?.flightfare?.totalnet != null)
      .map(flight => ({
        flight,
        price: flight.multifares[0].flightfare.totalnet
      }));
  
    // Sort flights by price
    priceFlight.sort((a, b) => (a.price - b.price) * priceOrder);
  
    // Update flight_list with the sorted flights
    this.flight_list = priceFlight.map(item => item.flight);
  }

  selectedFareIndex: number = 0; // Initialize with 0 to select the first fare by default

  selected_fare(index: number) {
    this.selectedFareIndex = index; // Update the selected fare index
  }
  
  setStep(index: number) {
    this.step = index;
  }

  activeSlides: SlidesOutputData;

  onTranslated(event: SlidesOutputData) {
    this.selectedFareIndex = event.startPosition || 0;
    console.log('Carousel translated, new start position:', this.selectedFareIndex);
  }
  // carouselWidth: string = '80%'; // Set the width dynamically if needed
  fareMultiFlight_: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    autoWidth:false,
    navSpeed: 700,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    lazyLoad:true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  };

  // Helper method to generate all dates in the range
  private generateDateRange(startDate: Date, endDate: Date): string[] {
    const dates = [];
    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      dates.push(this.util.formatDate(new Date(d), 'YYYY-MM-DD'));
    }
    return dates;
  }

  DynamicCalandarPrice(): void {
    const currentDate = new Date();
    const onwarddate__ = new Date(new Date(this.trip_type.onwarddate).setDate(new Date(this.trip_type.onwarddate).getDate() + 1));
    // console.log(onwarddate__); // Logs the date with one day added
    const startDate = new Date(currentDate); // this.trip_type.onwarddate
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 364);
    const sector = `${this.trip_type.origin}${this.trip_type.destination}`;
    this.http.flightsave(`apiV2/page/dynamic-calander-price`, {
      start_date: this.util.formatDate(startDate, 'YYYY-MM-DD'),
      end_date: this.util.formatDate(endDate, 'YYYY-MM-DD'),
      sector
    }).subscribe(res => {
      const priceMap = new Map(res.map(({ date, price }) => [date, price]));
      this.listCalandarPrice = this.generateDateRange(startDate, endDate).map(date => ({
        date,
        sector,
        price: priceMap.get(date) || '0',
        active: date === this.util.formatDate(onwarddate__, 'YYYY-MM-DD')
      }));

      // Update carousel options to set the start position
      this.dynamicCalander = {
        ...this.dynamicCalander,
        startPosition: this.listCalandarPrice.findIndex(item => item.date === this.util.formatDate(onwarddate__, 'YYYY-MM-DD'))
      };
    }, err => {this.util.errorMessage(err)});
  }
  

  // carouselWidth: string = '80%'; // Set the width dynamically if needed
  dynamicCalander: OwlOptions = {
    loop: false,
    margin: 8,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    autoWidth:false,
    navSpeed: 700,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    lazyLoad:true,
    nav: true,
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 6
      },
      1000: {
        items: 8
      }
    }
  };

  currentDate(date: string): void {

    this.util_flight.pushCurrentDate(date)
  }

  adultNum: number = 0;
  childNum: number = 0;
  infantNum: number = 0;

  initializeValues() {
    // Retrieve numbers of adults, children, infants, etc.
    this.adultNum = JSON.parse(localStorage.getItem('adultValue') || '0');
    this.childNum = JSON.parse(localStorage.getItem('childValue') || '0');
    this.infantNum = JSON.parse(localStorage.getItem('infantsValue') || '0');
    // console.log(this.adultNum, this.childNum, this.infantNum);
  }

}